<template>
    <div class="index-slider">
        <div class="bg">
            <div :style="{width:percentage+'%'}" class="progress-bar">

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'indexSlider',
        props:{
            percentage:Number
        },
        data() {
            return {
            }
        },
        computed: {

        },
        mounted() {
        },
        methods: {},
        components: {}
    }
</script>
<style  scoped>
    .bg{
        height: 6px;
        border-radius: 4px;
        background-color: #057EFB;
        border: 2px solid #057EFB;
        overflow: hidden;
        position: relative;
        vertical-align: middle;
    }
    .progress-bar{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background-color: #fff;
        text-align: right;
        line-height: 1;
        border-radius: 2px;

    }

</style>



// WEBPACK FOOTER //
// indexSlider.vue?5b8cb610